// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const specialProperty = 'exact-prop: \u200b';
export default function exactProp(propTypes) {
    if ("production" === 'production') {
        return propTypes;
    }
    return {
        ...propTypes,
        [specialProperty]: (props)=>{
            const unsupportedProps = Object.keys(props).filter((prop)=>!propTypes.hasOwnProperty(prop));
            if (unsupportedProps.length > 0) {
                return new Error("The following props are not supported: ".concat(unsupportedProps.map((prop)=>"`".concat(prop, "`")).join(', '), ". Please remove them."));
            }
            return null;
        }
    };
}
